import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, Divider, IconButton } from '@mui/material/';
import { DrawerHeader, PoweredByText, Logo } from './style';
import { ReactComponent as ChevronLeftIcon } from '../../assets/Expand.svg';
import { ReactComponent as ComdinheiroLogo } from '../../assets/Comdinheiro.svg';
import { useTypedTheme } from '@monorepo-web/styles';
import { useIsMobile } from '@monorepo-web/utils';
export default function PersistentDrawerLeft({ drawerwidth, ListaMenu, disabled, carteiraSelecionada, logo, isDrawerLeftOpen, setIsDrawerLeftOpen }) {
    const isMobile = useIsMobile();
    const theme = useTypedTheme();
    const handleDrawerClose = () => {
        setIsDrawerLeftOpen(false);
    };
    return (_jsx(Drawer, Object.assign({ sx: {
            width: drawerwidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
                width: drawerwidth,
                boxSizing: 'border-box',
            },
        }, PaperProps: {
            sx: {
                backgroundColor: theme.backgroundColorMain,
            },
        }, variant: "persistent", anchor: "left", open: isDrawerLeftOpen }, { children: _jsxs(_Fragment, { children: [_jsxs(DrawerHeader, Object.assign({ style: { borderRight: theme.borderRightMenu } }, { children: [_jsx(Logo, { src: logo.src || '', width: logo.width, height: logo.height }), carteiraSelecionada !== '-1' && (_jsx(IconButton, Object.assign({ onClick: handleDrawerClose }, { children: _jsx(ChevronLeftIcon, { stroke: theme.fontColorMenu, fill: "transparent" }) })))] })), _jsx(Divider, { sx: { bgcolor: theme.backgroundColorMenuDivider, borderRight: theme.borderRightMenu } }), _jsx(ListaMenu, { onClick: (e) => {
                        if (disabled) { // n�o permitir utilizar bot�o quando minizar o modal de loading
                            e.preventDefault();
                        }
                        else {
                            (isMobile ? setIsDrawerLeftOpen(false) : null);
                        }
                    } }), _jsxs("div", Object.assign({ style: {
                        display: 'flex',
                        height: '100%',
                        flexDirection: 'column-reverse',
                        borderRight: theme.borderRightMenu,
                    } }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex' } }, { children: [_jsx(ComdinheiroLogo, { style: { margin: 12 } }), _jsx(PoweredByText, { children: "Powered by Comdinheiro" })] })), _jsx(Divider, { sx: { bgcolor: theme.backgroundColorMenuDivider, borderRight: theme.borderRightMenu } })] }))] }) })));
}
